export default {
  TIME_UPDATE: 'TIME_UPDATE',
  LOADED_METADATA: 'LOADED_METADATA',
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  WAITING: 'WAITING',
  SEEKING: 'SEEKING',
  SEEKED: 'SEEKED',
  LOAD_START: 'LOAD_START',
  CAN_PLAY: 'CAN_PLAY',
  PLAYING: 'PLAYING',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
};
